import * as React from 'react';
import connectWithRouter from '../../components/redux/connectWithRouter';
import ActionsManager from '../ActionsManager';
import {OBJECT_TYPES_NAMES} from '../ActionsManagerConsts';
import {ebayListingsActionsMapStateToProps} from './EbayListingsActionsSelectors';
import {EbayListingsActionsProps} from './EbayListingsActionsConsts';

const EbayListingsActions: React.SFC<EbayListingsActionsProps> = props => {
  return <ActionsManager id="cla-btn" objectType={OBJECT_TYPES_NAMES.LISTING} {...props} />;
};

export default connectWithRouter(ebayListingsActionsMapStateToProps, {})<Partial<EbayListingsActionsProps>>(
  EbayListingsActions
);
